import Fetch from "utils/fetch";

export const downloadStockPolicy = () => {
  return Fetch.get(`labeled-family-centers:export-stock-policy`).then(({data}) => data);
} 

export const updateStockPolicy = (base64) => {
  return Fetch.put(`labeled-family-centers:import-stock-policy`, { Content: base64 }).then(({data}) => data);
}